import type { CommunicationConsent } from "./types"

function toConsent(item: unknown): CommunicationConsent | null {
  if (!item || typeof item !== "object") return null
  const record = item as Record<string, unknown>
  const text = String(record.text ?? "").trim()
  const rawId = record.subscriptionTypeId
  if (!text || (typeof rawId !== "string" && typeof rawId !== "number")) {
    return null
  }
  if (String(rawId).trim() === "") return null
  return {
    subscriptionTypeId: rawId,
    text,
    required: Boolean(record.required),
  }
}

export function parseCommunicationConsents(
  value: CommunicationConsent[] | string | undefined
): CommunicationConsent[] {
  if (!value) return []

  let items: unknown[] = []
  if (Array.isArray(value)) {
    items = value
  } else {
    const trimmed = value.trim()
    if (!trimmed) return []
    try {
      const parsed: unknown = JSON.parse(trimmed)
      if (!Array.isArray(parsed)) return []
      items = parsed
    } catch {
      return []
    }
  }

  return items.flatMap((item) => {
    const consent = toConsent(item)
    return consent ? [consent] : []
  })
}

export function communicationConsentKey(consent: CommunicationConsent): string {
  return String(consent.subscriptionTypeId)
}
